import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';

const labelSx = {
    position: 'relative',
    transform: 'none',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.primary',
    '&.Mui-focused': {
        color: 'text.primary',
    },
    '&.Mui-disabled': {
        color: 'text.primary',
    },
};

export let Dropdown = ({
    selectedValue,
    updateValue,
    options,
    placeholder,
    labelProperty,
    valueProperty,
    disabled,
    required,
    id,
    name,
    label,
    ariaLabelledBy,
    ariaLabel,
    error = false,
    helperText,
    fullWidth = true,
    sx,
    dataAutomationId,
}) => {
    const safeOptions = (options || []).filter(Boolean);

    // Autocomplete works with option objects; callers use plain values, so map both ways.
    const selectedOption = safeOptions.find(o => o[valueProperty] === selectedValue) || null;

    const handleChange = (event, option) => {
        if (updateValue) {
            updateValue(option ? option[valueProperty] : '');
        }
    };

    const helperId = id ? `${id}-helper` : undefined;
    const automationId = dataAutomationId || id;

    return (
        <FormControl fullWidth={fullWidth} disabled={disabled} error={error} sx={sx}>
            {label && (
                <InputLabel shrink htmlFor={id} required={required} sx={labelSx}>
                    {label}
                </InputLabel>
            )}
            <Autocomplete
                id={id}
                value={selectedOption}
                onChange={handleChange}
                options={safeOptions}
                getOptionLabel={(option) => (option && option[labelProperty] != null ? String(option[labelProperty]) : '')}
                isOptionEqualToValue={(option, value) => option[valueProperty] === value[valueProperty]}
                disabled={disabled}
                size="small"
                fullWidth={fullWidth}
                ListboxProps={automationId ? { 'data-automation-id': `${automationId}_listbox` } : undefined}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={placeholder}
                        error={error}
                        required={required}
                        inputProps={{
                            ...params.inputProps,
                            ...(name ? { name } : {}),
                            'aria-labelledby': ariaLabelledBy,
                            'aria-label': ariaLabel,
                            'aria-invalid': error || undefined,
                            'aria-describedby': (helperText && helperId) || undefined,
                            ...(required ? { 'aria-required': true } : {}),
                            ...(automationId ? { 'data-automation-id': automationId } : {}),
                        }}
                    />
                )}
            />
            <FormHelperText id={helperId} sx={{ my: 0 }}>{helperText || ' '}</FormHelperText>
        </FormControl>
    );
};

export default Dropdown;
